import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShoppingAcrossBusinessLinesEligibilityQuery } from './getShoppingAcrossBusinessLinesEligibility';

const useShoppingAcrossBusinessLinesEligibilityQuery = ({
  clientId,
  error,
  loading,
}) => {
  const variables = {
    clientId,
    configParamsInput: {
      offlineLookupOnly: true,
      params: [
        {
          name: 'eng.kufak.shopping_across_lines_of_business',
          fallbackValue: 'control',
          expectedValues: ['control', 'treatment'],
        },
      ],
    },
  };

  const {
    data: shoppingAcrossBusinessLinesEligibilityData,
    loading: shoppingAcrossBusinessLinesEligibilityLoading,
    error: shoppingAcrossBusinessLinesEligibilityError,
  } = useGetShoppingAcrossBusinessLinesEligibilityQuery({
    skip: error || loading,
    variables,
    onCompleted: () => {
      recordMark(
        'get_shopping_across_business_lines_eligibility_query_completed',
        {
          graph_query_succeeded: true,
        },
      );
    },
    onError: () => {
      recordMark(
        'get_shopping_across_business_lines_eligibility_query_completed',
        {
          graph_query_succeeded: false,
        },
      );

      sendLog(
        `GetShoppingAcrossBusinessLinesEligibility error: ${shoppingAcrossBusinessLinesEligibilityError}`,
        {
          errorMessage: shoppingAcrossBusinessLinesEligibilityError,
        },
      );
    },
  });

  return {
    shoppingAcrossBusinessLinesEligibilityData,
    shoppingAcrossBusinessLinesEligibilityLoading,
    shoppingAcrossBusinessLinesEligibilityError,
  };
};

export default useShoppingAcrossBusinessLinesEligibilityQuery;
